// extracted by mini-css-extract-plugin
module.exports = {"page":"MaterialValuesFreePage_page__yY8ON"};